<template>
  <div class="reports-index">
    <el-form class="search-filter">
      <div class="filter-worker">
        <date-picker
          lang="ru"
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          range
          v-model="filter.datetimeRange"
          @change="changeFiled"
        ></date-picker>
      </div>
      <div class="filter-worker">
        <filter-select
          v-if="userRole === 'admin'"
          v-model="filter.users"
          label="Выберите пользователя"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.users"
        />
        <strong style="margin-top: 10px;display: block;" v-if="userRole !== null && userRole !== 'admin'">{{filter.users.label}}</strong>
      </div>
      <div class="filter-worker">
        <filter-select
          v-model="filter.object"
          label="Выберите обьект"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.objects"
        />
      </div>
    </el-form>
    <dl class="info-block" v-if="allData !== null">
      <strong>Итого {{$store.getters.permission.price && $store.getters.permission.unit_name || 'стоимость'}}:</strong>
      <div class="analytics-views">
        <div class="analytic-row sum">
          <div class="analytics-info">
            <div>
              <span class="name">План</span>
              <strong>
                {{ (allData.price_plan).toFixed(2) }}
              </strong>
            </div>
            <div>
              <span class="name">Факт</span>
              <strong>{{ (allData.price_value).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">+/-</span>
              <strong>{{ (allData.price_value - allData.price_plan).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">%</span>
              <strong v-if="allData.plan !== 0">{{ (allData.price_value * 100 / allData.price_plan).toFixed(1) }}</strong>
            </div>
          </div>
        </div>
      </div>

    </dl>
    <h1 v-if="empty">
      <span v-if="(filter.object === null || filter.object.value === null)"> </span>
      <span v-else></span>
    </h1>
    <dl class="info-block"  v-if="!empty">
      <div class="analytics-views" v-loading="loader">
        <div v-for="row in analytics" class="analytic-row">
          <strong class="title">{{ row.name }}, {{ row.unit }}<small v-if="row.error">{{row.error}}</small></strong>

          <div class="analytics-info">
            <div>
              <span class="name">План</span>
              <strong>{{ (row.plan).toFixed(2) }}</strong>
            </div>
            <div>
              <span class="name">Факт</span>
              <strong>{{ (row.value).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">+/-</span>
              <strong>{{ (row.value - row.plan).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">%</span>
              <strong v-if="row.plan !== 0">{{ (row.value * 100 / row.plan).toFixed(1) }}</strong>
            </div>
          </div>
          <div class="analytics-info">
            <div>
              <span class="name">План</span>
              <strong>
                {{ (row.price_plan).toFixed(2) }}
              </strong>
            </div>
            <div>
              <span class="name">Факт</span>
              <strong>
                {{ (row.price_value).toFixed(2) }}
              </strong>
            </div>

            <div>
              <span class="name">+/-</span>
              <strong>{{ (row.price_value - row.price_plan).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">%</span>
              <strong v-if="row.plan !== 0">{{ (row.price_value * 100 / row.price_plan).toFixed(1) }}</strong>
            </div>
          </div>
        </div>
      </div>

    </dl>
  </div>



</template>


<script>
import firebase from 'firebase'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import FilterSelect from '../../../components/FilterSelect';
import {formatEndDate, formatStartDate} from "../../../utils/date";
import getItemsForUser from '../../../utils/getItemsForUser'


export default {
  name: 'Job',
  components: {DatePicker, FilterSelect},
  data () {
    return {
      loader: false,
      analytics: [],
      allData: null,
      empty: false,
      shortcuts: [
        {
          text: 'День',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'Неделя',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 7 * 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'Месяц',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 31 * 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'За все время',
          onClick () {
            return []
          },
        },
      ],
      filter: {
        users: null,
        object: null,
        typeJob: null,
        datetimeRange: [

        ],
      },
      filterCollection: {
        users: [],
        objects: [],
      },
      projectWorksType: {},
      workTypeMap:{},
      prepareJobs: {},
      mapJobs: {},
      userRole: null,
      mapTreeProject: {}
    }
  },
  mounted () {
    if (this.$store.state.project.disableDate) {
      this.filter.datetimeRange = [
        new Date('2021-08-24'),
        new Date('2021-09-02')
      ]
    }

    const defaultQuery = firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('reports')
      .where('type', '==', 'JOB')
    this.loader = true
    const promiseUser = this.fetchUsers(defaultQuery)
    const promiseObject = this.fetchObjects()
    Promise.all([promiseUser, promiseObject])
      .then(() => this.changeFiled())
      .then(() => {
        this.analytics = [];
        this.empty = this.analytics.length === 0;
        this.loader = false
      })

  },
  methods: {
    fetchObjects () {
      const objectsArray = []

      const loadObjectByParentId = (id, result = []) => {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('objects')
          .doc(id)
          .get().then(r => {
            const data = r.data();
            if (!data) {
              return result;
            }
            const {parentId, name, index}= data;
            result.push({id: id, name: name, index: index, parentId})
            if (!parentId) {
              return result
            }
            return loadObjectByParentId(parentId, result)

          })
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .get().then((response) => {
          response.forEach((sub) => {
            const data = {...sub.data(), ...{_id: sub.id,}}
            objectsArray.push(data)
          })
          return Promise.all(objectsArray.filter(item => !!item).map(item => loadObjectByParentId(item._id, [])))
        }).then(objectsArrayFromDirectory => {
          const objectsArray = objectsArrayFromDirectory.filter(i => i.length > 0).map((item) => {
            const reverseItem = item.reverse()
            if(reverseItem.length > 1){
              this.mapTreeProject[reverseItem[0].id] = this.mapTreeProject[reverseItem[0].id] || new Set();
              reverseItem.filter((i, index) => index > 0).forEach(item => this.mapTreeProject[reverseItem[0].id].add(item))
            }
            return {
              id: reverseItem[reverseItem.length - 1].id,
              name: reverseItem.map(item => item.name).join(' > '),
              index: reverseItem[reverseItem.length - 1].index
            }
          })
          const acumObject = {
            [null]: {
              value: null,
              label: 'Все обьекты',
            },
            ['all']: {
              value: 'all',
              label: 'Без обьекта',
            },
          }

          const filterObject = Object.values(
            objectsArray.filter(item => !!item)
              .sort((a, b) => {
                const fa = a.index
                const fb = b.index

                if (fa < fb) {
                  return -1
                }
                if (fa > fb) {
                  return 1
                }
                return 0
              })
              .reduce((acum, item) => (acum[item.id] = {value: item.id, label: item.name}, acum), acumObject),
          )
          return getItemsForUser(
            firebase.auth().currentUser.uid,
            this.$store.state.project.id
          ).then((accessData) => {
            return {accessData, filterObject}
          })
        })
        .then(({accessData, filterObject}) => {
          if (accessData.user.role === 'admin' || accessData.company.usePermission !== true) {
            this.filterCollection.objects = filterObject;
            return;
          }
          this.filterCollection.objects = filterObject.filter((item) => {
            return item.value === null || accessData.saveObject[item.value];
          })
        })
    },
    fetchUsers (defaultQuery) {
      const loadUserFromDirectory = (id) => {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .doc(id)
          .get().then(r => r.data())
      }
      const usersArray = []
      return defaultQuery
        .get().then((response) => {
          response.forEach((sub) => {

            const data = sub.data()
            usersArray.push(data.user)
          })
          return Promise.all(
            usersArray.map(i => loadUserFromDirectory(i.user_profile_id).then((r) => r || i))
          )

        }).then((usersArray) => {
          const users = Object.values(usersArray.reduce((acum, item) => (acum[item.uid] = item, acum), {}))
          const resultList = users.reduce((acum, i) => {
            const name = i.company || i.name || i.email
            acum[name] = acum[name] || []
            acum[name].push(i.uid)
            return acum
          }, {})
          const resultUser = Object.entries(resultList).map(([key, val]) => ({
            uid: val.join(','),
            company: key,
          }))
          resultUser.unshift({
            uid: null,
            company: 'Все исполнители',
          })

          this.filterCollection.users = resultUser.map((item) => ({
            value: item.uid,
            label: item.company || item.email,
          }));
        }).then(() => {
          return getItemsForUser(
            firebase.auth().currentUser.uid,
            this.$store.state.project.id
          )
        }).then(({user}) => {
          const {company, role} = user;
          this.userRole = role;
          if (role !== 'admin') {
            this.filterCollection.users = this.filterCollection.users.filter(value => value.label === company)
            this.filter.users = this.filterCollection.users[0]
            this.filter.users = this.filter.users || {label: company}
          }
        })
    },
    fetchPrepareJobs(){
      if (Object.keys(this.mapJobs).length > 0) {
        return Promise.resolve(this.mapJobs)
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .where('type', '==', 'JOB')
        .get().then(response => {
          const result = []
          response.forEach(sub => {
            result.push({...sub.data(), ...{_id: sub.id}})
          })
          this.mapJobs = result.reduce((acum, item) => {
            acum[item._id] = item;
            return acum;
          }, {})

          return this.mapJobs;
        });
    },

    changeFiled () {

      this.empty = undefined
      this.loader = true;
      let accessDataAllow;
      let query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .where('type', '==', 'JOB')

      if (this.filter.datetimeRange[0] && this.filter.datetimeRange[1]) {

        const endDate = this.filter.datetimeRange[1]
        const startDate = this.filter.datetimeRange[0]

        query = query.where('dateunix', '>=', formatStartDate(startDate))
        query = query.where('dateunix', '<=', formatEndDate(endDate))
      }
      if (this.filter.users && this.filter.users.value) {
        query = query.where('user.uid', 'in', this.filter.users.value.split(','))
      }

      const resultPromise = query.get().then((response) => {
        const result = []
        response.forEach((sub) => {
          result.push(...sub.data().jobs)
        })
        return result;
      })

      const jobsPromise =  this.fetchPrepareJobs()
        .then((jobs) => {
          return getItemsForUser(
            firebase.auth().currentUser.uid,
            this.$store.state.project.id
          ).then((accessData) => [jobs, accessData])
        })

        .then(( [jobs, accessData]) => {
          accessDataAllow = accessData;
        return Object.entries(jobs)
          // .filter(([key, val]) => {
          //   if (accessData.company.usePermission !== true) {
          //     return true;
          //   }
          //   return accessData.saveJobs[key]
          // })
          .reduce((acum, [key, i]) => {
          if (this.filter.object !== null) {
            if(this.mapTreeProject[this.filter.object.value]) {
              const treeObject = [...this.mapTreeProject[this.filter.object.value]]

              treeObject.map((tree) => {
                if (i.objects.indexOf(tree.id) > -1) {
                  acum['tree'] = acum['tree'] || [];
                  acum['tree'].push(i);
                }
              })
            }

            if (this.filter.object.value === null) {
              acum[i._id] = i;
            } else {
              if (this.filter.object.value === 'all' && (i.objects.length === 0 || i.objects[0] === 'all')) {
                acum[i._id] = i;
              }

              if (i.objects.indexOf(this.filter.object.value) > -1) {
                acum[i._id] = i;
              }
            }

          } else {
            acum[i._id] = i;
          }

          return acum;
        }, {});
      });

      const getUserFilterInfo = new Promise((resolve) => {
        if (!this.filter.users || !this.filter.users.value) {
          return resolve(null);
        }
        return getItemsForUser(this.filter.users.value.split(',')[0], this.$store.state.project.id).then((r) => {
          resolve(r)
        })
      })

      return Promise.all([resultPromise, jobsPromise, getUserFilterInfo]).then(([result, jobsPromise, userFilterInfo]) => {
        const {tree, ...jobs} = jobsPromise;
        const treeData = {plan: 0, value: 0, price_plan: 0, price_value: 0};
        const treeMapFilter = {};
        if (this.filter.object !== null && this.mapTreeProject[this.filter.object.value]) {
          const treeObject = [...this.mapTreeProject[this.filter.object.value]]
          treeObject
            .map(i =>
              tree
                .filter(a => {
                  if (userFilterInfo === null) {
                    return true
                  }

                  return userFilterInfo.saveJobs[a._id] && userFilterInfo.saveObject[i.id]
                })
                .filter(a => a.objects.indexOf(i.id) > -1)

            )
            .reduce((a, i) => {
              a.push(...i)
              return a;
            }, [])
            .reduce((acum, item) => {
              treeMapFilter[item._id] = true;
              acum.price_plan += isNaN(parseFloat(item.price_plan)) ? 0 : parseFloat(item.price_plan);
              acum.plan += isNaN(parseFloat(item.plan)) ? 0 : parseFloat(item.plan);
              return acum;
            }, treeData)

        }

        const r = result
          .filter(i => {
            if (this.filter.users && this.filter.users.value){
              if (userFilterInfo === null) {
                return true
              }

              return userFilterInfo.saveJobs[i.job.id]
            }
            return true;

          })
          .reduce((a, i) => {

          if (treeMapFilter[i.job.id]) {
            treeData.value += isNaN(parseFloat(i.value)) ? 0 : parseFloat(i.value)
            treeData.price_value += (isNaN(parseFloat(i.job.price_unit)) ? 0 : parseFloat(i.job.price_unit))  * (isNaN(parseFloat(i.value)) ? 0 : parseFloat(i.value))
          }

          if (!jobs[i.job.id]) {
            return a;
          }

          if (a[i.job.id]) {
            a[i.job.id].value += isNaN(parseFloat(i.value)) ? 0 : parseFloat(i.value)
            a[i.job.id].price_value += (isNaN(parseFloat(jobs[i.job.id].price_unit)) ? 0 : parseFloat(jobs[i.job.id].price_unit))  * (isNaN(parseFloat(i.value)) ? 0 : parseFloat(i.value))
          } else {
            a[i.job.id] = {
              name: jobs[i.job.id].name,
              unit: i.job.unit,
              plan: isNaN(parseFloat(jobs[i.job.id].plan)) ? 0 : parseFloat(jobs[i.job.id].plan),
              value: isNaN(parseFloat(i.value)) ? 0 : parseFloat(i.value),
              index: i.job.index,
              price_plan: isNaN(parseFloat(jobs[i.job.id].price_plan)) ? 0 : parseFloat(jobs[i.job.id].price_plan),
              price_value: (isNaN(parseFloat(jobs[i.job.id].price_unit)) ? 0 : parseFloat(jobs[i.job.id].price_unit))  * (isNaN(parseFloat(i.value)) ? 0 : parseFloat(i.value))
            }
          }
          return a
        }, {})
        Object.entries(jobs)
          .filter(([key, value]) => {

            if (accessDataAllow.user.role === 'admin') {
              if (this.filter.users && this.filter.users.value){
                return userFilterInfo.saveJobs[key];
              }
              return true;
            }

            if (Object.values(userFilterInfo.saveJobs).length === 0) {
              return true;
            }
            return userFilterInfo.saveJobs[key]
          })
          .reduce((acum, [key, value]) => {

            r[key] = {...{
                name: value.name,
                unit: value.unit,
                plan: isNaN(parseFloat(value.plan)) ? 0 : parseFloat(value.plan),
                value: 0,
                index: value.index,
                price_plan: isNaN(parseFloat(value.price_plan)) ? 0 : parseFloat(value.price_plan),
                price_value: 0
              }, ...r[key]}
          return r
        }, r)


        this.analytics = Object.values(r)
          .sort((a, b) => a.index > b.index && 1 || -1)

        const allData = Object.values(r).reduce((acum, item) => {
          acum.plan += isNaN(parseFloat(item.plan)) ? 0 : parseFloat(item.plan)
          acum.value += isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value)
          acum.price_plan += isNaN(parseFloat(item.price_plan)) ? 0 : parseFloat(item.price_plan)
          acum.price_value += isNaN(parseFloat(item.price_value)) ? 0 : parseFloat(item.price_value)
          return acum;
        }, treeData)

        if (this.analytics.length === 0 && allData.price_plan === 0) {
          this.allData = null
        }

        this.allData = allData;
        if (this.filter.object === null || this.filter.object.value === null) {
          this.analytics = [];
          this.empty = true;
        } else {
          this.empty = this.analytics.length === 0
        }

        this.loader = false;
      })
    },
  }

}
</script>



<style scoped lang="scss">

.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

@media screen and (min-width: 764px) {
  .filter-worker {
    height: 48px;
  }
}

.chart-div {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  div {
    width: 500px !important;
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
  }
}

.info-block {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

dl {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

dt {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: right;
  box-sizing: border-box;
  padding-right: 10px;
  font-weight: bold;
  margin: 0px;
}

dd {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
  margin: 0px;
}

> > > .mx-datepicker-range {
  width: 100%;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

> > > .el-table__body {
  .cell {
    font-weight: 600;
  }
}

.analytics-views {
  width: calc(100% - 40px);
  margin: 10px auto 22px auto;
  padding-top: 0px;
}

.analytic-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-top: 15px;
  flex-direction: column;
  &.sum{
    border-bottom: 2px solid #3a8ee6;
  }
  .title {
    margin-bottom: 4px;
  }

  .name {
    margin-right: 8px;
  }
}

.analytics-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
  padding-top: 0;
  flex: 1;

  div {
    text-align: left;
    width: 25%;
    &:last-child{
      text-align: right;
    }
  }
  //.row-1{
  //  text-align: left;
  //  width: 40%;
  //}
  //.row-2{
  //  text-align: left;
  //  width: 20%;
  //}
  //.row-3{
  //  text-align: left;
  //}

  .name {
    color: #3a8ee6;
    font-weight: 600;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 764px) {
  .analytics-info {
    flex-direction: column;

    div {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/JobPrice.vue